// 成绩统计核心：有效成绩、PB、Ao5/Ao12、滚动平均

// 有效成绩 = raw time + 罚时（DNF 为 null）
export function effectiveTime(solve) {
  if (!solve || solve.penalty === 'dnf') return null;
  return solve.time_ms + (solve.penalty === '+2' ? 2000 : 0);
}

export function isDnf(solve) {
  return solve && solve.penalty === 'dnf';
}

// 计算一组成绩的平均（去掉最好最差）。返回 null 表示无效。
// WCA 规则：Ao5 允许 1 个 DNF，Ao12 允许 2 个 DNF；DNF 视为最差
export function trimmedAverage2(solves) {
  if (!solves || solves.length < 3) return null;
  const n = solves.length;
  const maxDnf = n >= 12 ? 2 : 1;
  const dnfCount = solves.filter(isDnf).length;
  if (dnfCount > maxDnf) return null;

  // 有效成绩排序
  const withTime = solves.map((s, i) => ({ time: effectiveTime(s), i }));
  const valid = withTime.filter((x) => x.time !== null).sort((a, b) => a.time - b.time);
  const worstIsDnf = dnfCount > 0;

  let sum = 0;
  let count = 0;
  let removedBest = false;
  let removedWorst = false;
  for (const x of valid) {
    if (!removedBest) { removedBest = true; continue; }
    if (!removedWorst && worstIsDnf && valid.length - 1 === count) { removedWorst = true; continue; }
    sum += x.time;
    count++;
  }
  if (count === 0) return null;
  return sum / count;
}

export const average = trimmedAverage2;

// 从按时间升序排列的成绩里计算滚动 Ao5/Ao12
export function rollingAverages(solves, windowSize = 5) {
  const out = [];
  if (!solves || solves.length === 0) return out;
  for (let i = windowSize - 1; i < solves.length; i++) {
    const slice = solves.slice(i - windowSize + 1, i + 1);
    out.push({ index: i, at: slice[slice.length - 1].created_at, solves: slice, value: trimmedAverage2(slice) });
  }
  return out;
}

export function bestAverage(solves, windowSize = 5) {
  if (!solves || solves.length < windowSize) return null;
  let best = null;
  for (let i = windowSize - 1; i < solves.length; i++) {
    const slice = solves.slice(i - windowSize + 1, i + 1);
    const v = trimmedAverage2(slice);
    if (v !== null && (best === null || v < best)) best = v;
  }
  return best;
}

export function bestSingle(solves) {
  let best = null;
  for (const s of solves || []) {
    const t = effectiveTime(s);
    if (t !== null && (best === null || t < best)) best = t;
  }
  return best;
}

export function lastNAverage(solves, n) {
  if (!solves || solves.length === 0) return null;
  const slice = solves.slice(-n);
  const valid = slice.map(effectiveTime).filter((t) => t !== null);
  if (valid.length === 0) return null;
  return valid.reduce((a, b) => a + b, 0) / valid.length;
}

// 连续打卡天数（基于已有打卡的日期集合，从最近一天向前推）
export function currentStreak(dateKeys) {
  const set = new Set(dateKeys);
  let streak = 0;
  const d = new Date();
  // 若今天还没打卡，从昨天开始算
  if (!set.has(dayKey(d))) d.setDate(d.getDate() - 1);
  while (set.has(dayKey(d))) {
    streak++;
    d.setDate(d.getDate() - 1);
  }
  return streak;
}

export function dayKey(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
